import script from "./file-upload-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./file-upload-widget-ly.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__